// A self-contained pin icon (inline SVG data URI) for plain "here's a location"
// Google Maps markers. The library's *default* marker icon is an image fetched
// from Google's own CDN — ad-blockers/privacy extensions commonly block it,
// which leaves the marker invisible while the map tiles still render fine.
// Every other marker in this app already draws its own icon (vector symbols,
// a custom car icon) for the same reason; this gives plain location pins the
// same immunity.
export function mapPinIcon(color = '#f68b2c'): google.maps.Icon {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40">
  <path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 25 15 25s15-14.5 15-25C30 6.7 23.3 0 15 0z" fill="${color}" stroke="#ffffff" stroke-width="2"/>
  <circle cx="15" cy="15" r="5.5" fill="#ffffff"/>
</svg>`
  return {
    url: `data:image/svg+xml;base64,${btoa(svg)}`,
    scaledSize: new google.maps.Size(30, 40),
    anchor: new google.maps.Point(15, 40),
  }
}
